// extracted by mini-css-extract-plugin
module.exports = {"container":"EstimateEquValue_container__2F7By"};